<template>
  <div v-if="title"
       class="bx-header__navi-group-headline">
    {{ title }}
  </div>
</template>

<script>

export default {
  name: 'MenuGroupHeadline',
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
